var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCanvassers = function SvgCanvassers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15 2.75a3.5 3.5 0 1 1 0 7m3.25 3.759c2.078.736 3.722 2.464 4.503 4.308.54 1.271-.622 2.433-2.003 2.433M9.25 9.75a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7m-7.578 7.57c1.265-2.636 4.182-4.57 7.578-4.57s6.313 1.934 7.578 4.57c.717 1.494-.671 2.899-2.328 2.899H4c-1.657 0-3.045-1.405-2.328-2.899"
  })));
};
export default SvgCanvassers;